import * as React from 'react';

import moment from 'moment';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AppState from '../../../../store/state';
import { Translate } from 'react-localize-redux';
import { UpdateField } from '@webapp/store/release/action-creators';

import { CalendarTiers, getCalendarTiers } from '@webapp/sdk/plans';
import { getSelectedTier } from '@webapp/utils/plans/get-selected-tiers';

import Datepicker from '@components/form/datepicker';
import AnimatedHintCtrl from '@webapp/controllers/animated-hint';
import DatepickerPriceItem from '@components/form/datepicker/datepicker-prices/datepicker-price-item';
import { ReleaseHistory } from '@common/types/release/release-history';
import { releaseDateWasPaid } from '@webapp/store/release/selectors';
import { Release } from '@common/types/release/release';

interface NewReleaseTab {
  className?: string;
  releaseDate?: string;
  datePriceTiers: CalendarTiers;
  releaseHistory: ReleaseHistory;
  requestChanges: boolean;
  release?: Partial<Release>;
  isProArtist?: boolean;
  updateReleaseDate: (date?: string) => UpdateField<'releaseDate'>;
}

const mapStateToProps = (state: AppState) => {
  const calendarTiers = getCalendarTiers(
    state.release.release?.trackCount || 1
  );
  return {
    releaseDate: state.release.release?.releaseDate,
    datePriceTiers: calendarTiers,
    releaseHistory: state.release.release?.releaseHistory || 'new',
    requestChanges:
      state.release.release?.backofficeStatus === 'request-changes',
    release: state.release.release,
    isProArtist: state.subscription.current?.plan.toLowerCase().includes('pro'),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateReleaseDate: (date?: string) =>
    dispatch(new UpdateField<'releaseDate'>('releaseDate', date)),
});

export const getMinDate = () => moment().startOf('day').add(2, 'days');

const NewReleaseTabCtrl: React.FC<NewReleaseTab> = ({
  className,
  releaseDate,
  datePriceTiers,
  updateReleaseDate,
  releaseHistory,
  release,
  isProArtist,
}) => {
  const [activeDate] = React.useState(moment(releaseDate));

  const selectedTier = !releaseDateWasPaid(release)
    ? getSelectedTier(datePriceTiers.priceTiers, releaseDate)
    : undefined;
  const selectedPrice: number | undefined = !isProArtist
    ? datePriceTiers.priceTiers.find((p) => p.name === selectedTier)?.price
    : undefined;

  return (
    <div className={className}>
      <div className="datepicker-wrapper">
        <Datepicker
          id="datepicker"
          title={
            releaseHistory === 'previous'
              ? 'Future Release Date'
              : 'Release Date'
          }
          value={
            releaseDate
              ? moment(releaseDate).format('MMMM DD, YYYY')
              : undefined
          }
          active={activeDate}
          min={getMinDate()}
          onChange={(value) => updateReleaseDate(value)}
          priceTiers={isProArtist ? [] : datePriceTiers.priceTiers}
        />
        {selectedTier && selectedPrice && (
          <DatepickerPriceItem
            className="decoration"
            type={selectedTier}
            price={selectedPrice}
            small
          />
        )}
      </div>
      {!isProArtist && selectedTier && (
        <AnimatedHintCtrl
          className="mt-10"
          customTitle={<Translate id="RELEASE.DATE.PRICING" />}
        />
      )}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewReleaseTabCtrl);
